function BookkeepingOperatorService($http, AppSettings) {
  'ngInject';

  const service = {};

  function basePath(orgId) {
    return AppSettings.apiUrl + '/organizations/' + orgId + '/bookkeeping';
  }

  service.clients = function (orgId) {
    return $http.get(basePath(orgId) + '/clients');
  };

  service.runs = function (orgId, params) {
    return $http.get(basePath(orgId) + '/runs', { params: params });
  };

  service.mappingReview = function (orgId, params) {
    return $http.get(basePath(orgId) + '/mapping_review', { params: params });
  };

  service.artifacts = function (orgId, params) {
    return $http.get(basePath(orgId) + '/artifacts', { params: params });
  };

  service.saveMappingDecisions = function (orgId, data) {
    return $http.post(basePath(orgId) + '/mapping_decisions', data);
  };

  service.generateReport = function (orgId, data) {
    return $http.post(basePath(orgId) + '/reports/generate', data);
  };

  return service;
}

BookkeepingOperatorService.$inject = ['$http', 'AppSettings'];

export default {
  name: 'BookkeepingOperatorService',
  fn: BookkeepingOperatorService
};
